import React from 'react'
import Route from 'react-router/lib/Route'
import IndexRoute from 'react-router/lib/IndexRoute'

import App from 'containers/App'
import Login from 'containers/Auth/Login'
import Logout from 'containers/Auth/Logout'

import Admin from 'containers/Admin'
import Dashboard from 'containers/Admin/Dashboard'
import Account from 'containers/Account'

import Grades from 'containers/Grades'
import GradesDefault from 'containers/Grades/default'
import GradesShow from 'containers/Grades/show'
import GradesSubmitted from 'containers/GradesSubmitted'

import Print from 'containers/Print'
import PrintGradesSubmitted from 'containers/Print/GradesSubmitted'

import auth from 'containers/Admin/authentication'

export default function createRoutes(store) {
  return (
    <Route component={App}>
      <Route path="/login" component={Login} />
      <Route path="logout" component={Logout} onEnter={Logout.onEnter(store)} />
      <Route path="/" component={Admin} onEnter={auth(store)}>
        <IndexRoute component={Dashboard} />
        <Route path="account" component={Account} />
        <Route path="grades" component={Grades} onEnter={Grades.onEnter(store)}>
          <IndexRoute component={GradesDefault} />
          <Route path=":offeringGroupID" component={GradesShow} onEnter={GradesShow.onEnter(store)} onLeave={GradesShow.onLeave(store)} />
        </Route>
        <Route path="grades-submitted" component={GradesSubmitted} />
      </Route>
      <Route path="print" component={Print}>
        <Route path="grades-submitted/:ID" component={PrintGradesSubmitted} />
      </Route>
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js